/**
 * @desc 查询全部受益部门列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.RevenueDepartmentResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/revenueDepartment/getListAll`, {
      method: "POST",

      ...options,
    }),
  );
}
